module.exports = __webpack_public_path__ + "angular-technologies.5_AWikMe.svg";